import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import dayjs from 'dayjs';
import { compose } from 'redux';
import styled from 'styled-components';

import DateSelector from '../../components/date-selector';
/**
 * Components
 */
import IncrementSelector from '../../components/increment-selector';
import { TIMESLOT_SELECT_CUT_OFF_TIME } from '../../constants';
import formatCurrency from '../../utilities/format-currency';
import { STORE_TIMESLOT_AS } from './constants';
/**
 * Selectors
 */
import { getDateInfo, getStartOfMonth } from './selectors';
import SwipeableContainer from './swipeable-container';

const Price = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 0 0 1em;
  font-size: 1.2em;
  font-weight: bold;
`;

const PriceText = styled.div`
  align-items: center;
  display: flex;
  color: ${props =>
    props.isWeekday ? props.theme.weekday : props.theme.holiday};

  &::before {
    content: '';
    display: inline-block;
    margin-right: 0.4em;
    height: 0.8em;
    width: 0.8em;
    background: ${props =>
      props.isWeekday ? props.theme.weekday : props.theme.holiday};
  }
`;

/**
 * Booking form component
 * Houses all logic for booking games and is redux aware
 */
class Calendar extends PureComponent {
  /**
   * Callback for month selector
   * @param {number} diff The requested change to month, whether it be to plus or minus a month
   */
  onMonthChange = diff => {
    const newDate = dayjs(this.props.month).add(diff, 'M');
    this.props.onTimeChange('calendar', newDate);
  };

  /**
   * Callback for date selector
   * @param {string} date New date selected
   */
  onDayClick = date => {
    const newDate = dayjs(date);
    this.props.onTimeChange('schedule', newDate);
  };

  /**
   * @inheritDoc
   */
  render() {
    const { game, month, dateInfo, style, onClick } = this.props;
    return (
      <SwipeableContainer
        className="swipe"
        onClick={onClick}
        onSwipedLeft={() => this.onMonthChange(1)}
        onSwipedRight={() => this.onMonthChange(-1)}
        style={style}
        trackMouse
      >
        <IncrementSelector onClick={this.onMonthChange}>
          {month.format('YYYY年 M月')}
        </IncrementSelector>
        {game && (
          <Price>
            <PriceText isWeekday={true}>
              &yen;{formatCurrency(game.weekdayPrice)}
            </PriceText>
            <PriceText isWeekday={false}>
              &yen;{formatCurrency(game.holidayPrice)}
            </PriceText>
          </Price>
        )}
        <DateSelector
          dateInfo={dateInfo}
          month={month}
          onClick={this.onDayClick}
        />
      </SwipeableContainer>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = (state, props) => ({
  gameId: state.global.gameId,
  month: getStartOfMonth(state, props),
  dateInfo: getDateInfo(state, props)
});

export default compose(
  connect(mapStateToProps, null),
  firebaseConnect(({ month, gameId }) => {
    const startOfBookingWindow = dayjs().subtract(
      TIMESLOT_SELECT_CUT_OFF_TIME,
      'minute'
    );
    const startOfMonth = month.isBefore(startOfBookingWindow)
      ? startOfBookingWindow
      : month;
    const endOfMonth = dayjs(month).endOf('month');
    return [
      {
        path: `timeslots/${gameId}`,
        queryParams: [
          'orderByChild=time',
          'startAt=' + startOfMonth.unix(),
          'endAt=' + endOfMonth.unix()
        ],
        storeAs: STORE_TIMESLOT_AS
      },
      {
        path: `/games/${gameId}`
      }
    ];
  })
)(Calendar);
